import { api } from "../../api/endpoints";
import {
    GET_CUSTOMER_SUBSCRIPTION_DETAILS_AD,
    GET_CUSTOMER_SUBSCRIPTION_DETAILS_AD_FAIL,
} from "../constant";


export const getCustomer = (customerId) => {
    return async (dispatch) => {
        try {
            const response = await api.get(`/payment/getSubscriptionDetailsForAdmin/${customerId}`);
            if(response.status == 200) {
                dispatch({
                    type: GET_CUSTOMER_SUBSCRIPTION_DETAILS_AD,
                    payload: response.data
                })
            }
        } catch (err) {
            dispatch({
                type: GET_CUSTOMER_SUBSCRIPTION_DETAILS_AD_FAIL,
                payload: true
            })
            setTimeout(() => {
                dispatch({
                    type: GET_CUSTOMER_SUBSCRIPTION_DETAILS_AD_FAIL,
                    payload: false
                })  
            }, 3000)
        }
    };
};

